// Global Types
import type {
  $Translate,
} from 'common.language';

// Global Components
import * as React from 'react';

// Helpers
import config from '../../../config';

// Types
type $Props = $Translate;

const FooterView = function ({
  t,
}: $Props) {
  return (
    <footer>
      <div className={'footer flex flex-row justify-between'}>
        <nav className={'ml-0-i flex flex-col sm:flex-row min-w-max mr-3'}>
          <span>
            &copy;
            {new Date().getFullYear()}
            {' '}
            {'- Regattas.eu'}
          </span>
          <span className={'divider text-gray-600-i hidden sm:block'}>{'|'}</span>
          <a href={`https://${config.DOMAIN}/page/privacy-policy`}>
            {t('Privacy policy')}
          </a>
          <span className={'divider text-gray-600-i hidden sm:block'}>{'|'}</span>
          <a href={'mailto:Regattas.eu<info@regattas.eu>?subject=Hello'}>
            {t('Contact')}
          </a>
        </nav>
        <nav className={'flex flex-row'}>
          <a
            className={'btn btn_primary btn_outlined uppercase hidden md:block mr-3'}
            href={`${config.PUBLIC_API_URL}/docs`}
            rel={'noreferrer'}
            target={'_blank'}
            title={t('Public api')}
          >
            {t('Api')}
          </a>
          <a
            className={'btn btn_secondary btn_outlined uppercase text-center'}
            href={config.ADMIN_URL}
            rel={'noreferrer'}
            target={'_blank'}
          >
            {t('Create and manage regattas')}
          </a>
        </nav>
      </div>
    </footer>
  );
};

export default FooterView;
